import {
	getMipKYCData,
	getMipKYCStatisticsData,
} from '@dealstack/frontend/shared/dataExchange/services/mip-manage.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useInvestorKYC } from './ManageKYCTable/hook/useInvestorKYC';
import { usePaginationWithSearch } from './hook/usePaginationWithSearch';
import { KYC_PAGINATION_PARAMS } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/constants';

export const useManageKYCController = (investorId?: string, kycWorkflowId?: string) => {
	const [investorDetailView, setInvestorDetailView] = useState(false);

	const {
		pagination: kycTablePagination,
		searchQuery,
		onSearchQueryChange,
	} = usePaginationWithSearch({
		defaultOffset: KYC_PAGINATION_PARAMS.DEFAULT_OFFSET,
		defaultLimit: KYC_PAGINATION_PARAMS.DEFAULT_LIMIT,
	});

	const getMipKYCDataRequest = useQuery({
		queryKey: [
			API_PATHS.MIP_KYC_INVESTORS_GET,
			{
				searchQuery,
				offset: kycTablePagination.state.offset,
				limit: kycTablePagination.state.limit,
			},
		],
		queryFn: ({ signal }) =>
			getMipKYCData(
				API_PATHS.MIP_KYC_INVESTORS_GET,
				{
					searchQuery,
					offset: kycTablePagination.state.offset,
					limit: kycTablePagination.state.limit,
				},
				signal
			),
		enabled: !investorId,
	});

	const getInvestorKYCDataRequest = useInvestorKYC(true, investorId, kycWorkflowId);

	const getKYCDataRequest = investorId ? getInvestorKYCDataRequest : getMipKYCDataRequest;
	const getMipKYCStatisticsDataRequest = useQuery({
		queryKey: [API_PATHS.MIP_KYC_STATISTICS_GET],
		queryFn: ({ signal }) => getMipKYCStatisticsData(API_PATHS.MIP_KYC_STATISTICS_GET, signal),
		enabled: !investorId,
	});

	useEffect(() => {
		const newValue = getMipKYCDataRequest.data?.payload?.totalRecord;
		if (!newValue) {
			return;
		}
		kycTablePagination.onTotalNumberOfItemsChange(newValue);
	}, [getMipKYCDataRequest.data?.payload?.totalRecord]);

	const investors = investorId
		? getInvestorKYCDataRequest?.data?.payload?.investors
		: getMipKYCDataRequest.data?.payload?.investors;

	return {
		summary: getMipKYCStatisticsDataRequest.data?.payload,
		investors,
		totalRecord: getMipKYCDataRequest.data?.payload?.totalRecord,
		onSearchQueryChange,
		kycTablePagination,
		investorDetailView,
		setInvestorDetailView,
		getKYCDataRequest,
	};
};
